import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/account',
    method: 'get'
  })
}

export function updateInfo(data) {
  return request({
    url: '/account',
    method: 'put',
    data
  })
}

export function logout() {
  return request({
    url: '/account/logout',
    method: 'post'
  })
}
